module.exports = __webpack_public_path__ + "static/Mastercard-8f20382553bb79cd181f1f20fbbff680.svg";